const FALLBACK_APP_VERSION = '1.0.0';

/**
 * Reads the application version from environment or falls back to a static value.
 */
export function getAppVersion(): string {
  const rawVersion = (import.meta.env?.VITE_APP_VERSION as string | undefined) ?? FALLBACK_APP_VERSION;
  if (typeof rawVersion !== 'string' || rawVersion.trim().length === 0) {
    return FALLBACK_APP_VERSION;
  }
  return rawVersion.trim();
}

